import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import Wizard from './components/Wizard'
import AdminLogin from './admin/AdminLogin'
import AdminLayout from './admin/AdminLayout'
import OrdersPage from './admin/OrdersPage'
import BookingsPage from './admin/BookingsPage'
import LabelsPage from './admin/LabelsPage'
import GiftPickerPage from './admin/GiftPickerPage'
import ProtectedRoute from './admin/ProtectedRoute'
import { SettingsPage } from './admin/SettingsPage'
import { DataOptionsPage } from './admin/DataOptionsPage'
import { PricingPage } from './admin/PricingPage'
import { EditOrderPage } from './admin/EditOrderPage'
import { PayOrderPage } from './pages/PayOrderPage'

const queryClient = new QueryClient()

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Wizard />} />
          <Route path="/pay/:orderId" element={<PayOrderPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<OrdersPage />} />
            <Route path="orders" element={<OrdersPage />} />
            <Route path="orders/:id" element={<EditOrderPage />} />
            <Route path="bookings" element={<BookingsPage />} />
            <Route path="labels" element={<LabelsPage />} />
            <Route path="gift-picker" element={<GiftPickerPage />} />
            <Route path="pricing" element={<PricingPage />} />
            <Route path="data-options" element={<DataOptionsPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}

export default App
